module.exports = __webpack_public_path__ + "static/img/6543_phase_function_Paper_PointsHejduk_Prediction.9b6ff31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6543_phase_function_Paper_PointsHejduk_Prediction.png
// module id = BCec
// module chunks = 0